import { TranslateService } from '@ngx-translate/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from "angular";

(function () {
    'use strict';

    angular
        .module('salesflare.downgraded.services.translateService', [])
        .factory('ngxTranslateService', downgradeInjectable(TranslateService));
})();

